"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = update;
async function update(invoiceRepo, invoice) {
    return await invoiceRepo.update(invoice);
}
